import api from './client';

export const getStats = () => api.get('/admin/stats');

export const getUsers = (page = 1, limit = 100) =>
  api.get(`/admin/users?page=${page}&limit=${limit}`);

export const getUser = (userId) =>
  api.get(`/admin/users/${userId}`);

export const promoteUser = (userId) =>
  api.patch(`/admin/users/${userId}/promote`);

export const getBots = (grouped = true, userId = null) => {
  let url = `/admin/bots?grouped=${grouped}`;
  if (userId) url += `&user_id=${userId}`;
  return api.get(url);
};

export const toggleBot = (botId) =>
  api.patch(`/admin/bots/${botId}/active`);

export const getInvoices = (page = 1, limit = 20, status = null, userId = null) => {
  let url = `/admin/invoices?page=${page}&limit=${limit}`;
  if (status) url += `&status=${status}`;
  if (userId) url += `&user_id=${userId}`;
  return api.get(url);
};

export const getUnpaidInvoices = () =>
  api.get('/admin/invoices/unpaid');

export const generateInvoice = (botId, userId, year, month, feePercentage, dueDays = 7) =>
  api.post(`/admin/invoices/generate?user_id=${userId}`, {
    bot_id: botId,
    year,
    month,
    fee_percentage: feePercentage,
    due_days: dueDays
  });

export const payInvoice = (invoiceId, paymentMethod, transactionId = null, notes = null) =>
  api.post(`/admin/invoices/${invoiceId}/pay`, {
    payment_method: paymentMethod,
    transaction_id: transactionId,
    notes
  });

export const cancelInvoice = (invoiceId, reason) =>
  api.post(`/admin/invoices/${invoiceId}/cancel?reason=${encodeURIComponent(reason)}`);

export const getSettings = () =>
  api.get('/admin/settings');

export const updateSettings = (feePercentage) =>
  api.patch(`/admin/settings?fee_percentage=${feePercentage}`);

export const stopAllBots = () =>
  api.post('/bots/stop_all_active');

export const startAllBots = () =>
  api.post('/bots/start_all_prev_active');
